
import ky from './kyextended';


const customerData = () =>  ky.get('v1/stripe-helper/customer/', {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const checkoutSession = (price_id) =>  ky.post('v1/stripe-helper/create-checkout-session/', {
    json: {
        price_id: price_id,
        is_billing_address_required: true
    },
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const getPlans = () =>  ky.get('v1/stripe-helper/prices/', {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const getCardDetails = () => ky.get('v1/stripe-helper/card/info/', {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const upgradeSubscription = (price_id) => ky.patch('v1/stripe-helper/subscription/', {
    json: {
        price_id: price_id,
    },
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const deleteSubscription = (price_id) => ky.delete('v1/stripe-helper/subscription/', {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const changeCard = () => ky.get('v1/stripe-helper/card/', {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json()

const verifyInvoice = (price_id) => ky.post('v1/stripe-helper/invoices/estimate/', {
    json: {
        price_id: price_id,
    },
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const getInvoices = () =>ky.get('v1/stripe-helper/invoices/', {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();


export { customerData, checkoutSession, getPlans,
    getCardDetails, upgradeSubscription, deleteSubscription, 
    changeCard, verifyInvoice, getInvoices
}